import {_request, _requestForm} from "./api";

export const listNotification = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'notification', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};
